import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { createQueryKey } from '@hero/utils';

import * as services from '../../services';

export const useGetLLMSuggestionsProductFilters = (body, options) => {
  return useQuery({
    queryKey: createQueryKey(QUERY_KEYS.useGetLLMSuggestionsProductFiltersKey, body),
    queryFn: async () => {
      return await services.getLLMSuggestionsProductFilters(body);
    },
    ...options
  });
};
